import React, { useState, useEffect, useRef } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import PatientInfo from "./PatientInfo";
import { NavLink } from "react-router-dom";
import { Box, Button, CircularProgress, Grid, IconButton, Modal, Typography, Drawer, Divider } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import HomeIcon from "@mui/icons-material/Home";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import RenderProgress from "./RenderProgress";
import RenderColor from "./RenderColor";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import { store } from "../redux/store/index";
import { useSelector } from "react-redux";
import * as patientAction from "../redux/actions/patientActions";
import KeyboardDoubleArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import PauseOutlinedIcon from "@mui/icons-material/PauseOutlined";
import KeyboardDoubleArrowRightOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowRightOutlined";
import SquareIcon from "@mui/icons-material/Square";
import { ConsultationContext, } from "../context/ConsultationContext";
import * as consultationActions from "../redux/actions/consultationActions";
import { API } from "../api/api";
import Tooltip from '@mui/material/Tooltip';
import taskIcon from "../assets/taskIcon.png";
import { useToast } from "../context/ToastContext";
import { ReactComponent as LeftArrow } from '../assets/left.svg';
import { ReactComponent as Pause } from '../assets/pause.svg';
import { ReactComponent as RightArrow } from '../assets/right.svg';
import { ReactComponent as EndConsult } from '../assets/end.svg';
import { ReactComponent as DisabledEnd } from '../assets/disabledEnd.svg'
import { ReactComponent as DisabledRight } from '../assets/disabledRight.svg'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ClearIcon from '@mui/icons-material/Clear';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import ErrorIcon from '@mui/icons-material/Error';
import { socket } from "../socket/socket";
import usePermissions from "../utils/permissions";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Dialog, DialogContent, } from "@mui/material";
import { END_POINTS } from "../api/endpoints";
import { trackEvent } from "../utils/firebase";
import PatientHeader from "./Cards";
import VideoCall from '../pages/VideoCall';

const style = {
  width: {
    xs: '85%',
    sm: '60%',
    md: '30%',
    lg: '30%',
    xl: '30%',
  },
  bgcolor: '#F2F2F2',
  outline: 'none',
  borderRadius: '10px',
  p: 2,
  height: { xs: 'auto', md: '12%' },
  minHeight: { xs: '120px' },
  justifyContent: 'space-between',
  display: 'flex',
  flexDirection: 'column'
};

const actionButtonStyle = { cursor: 'pointer', display: 'flex', backgroundColor: '#D7F5FF', padding: 1, borderRadius: '10px', boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.15)', width: { xs: 'auto', sm: '140px', md: '155px' }, flex: { xs: 1, sm: 'none' }, justifyContent: 'center', alignItems: 'center' }

const Consultation = () => {
  const { patientId, consultationId } = useParams();
  const patientReducer = useSelector((state) => state.patientReducer);
  const consultationReducer = useSelector((state) => state.consultationReducer);
  const [leapData, setLeapScoreData] = useState({});
  const [childData, setChildData] = useState(null);
  const location = useLocation();
  const route = location.pathname.split("/").pop().toLowerCase();
  const navigate = useNavigate();
  const [edit, setEdit] = useState(true);
  const showToast = useToast()
  const exceptionRoute = ['history', "vitals", 'treatment', 'observation', 'antenatal'].includes(route)
  const [showEndConsultationModal, setShowEndConsultationModal] = useState(false);
  const [showPdfPromptModal, setShowPdfPromptModal] = useState(false);
  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
  const [prescriptionUrl, setPrescriptionUrl] = useState("");
  const [hasSignature, setHasSignature] = useState(false);
  const fileInputRef = useRef(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [patientDrawerOpen, setPatientDrawerOpen] = useState(false);
  const { hasPermission } = usePermissions();

  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [patientSummaries, setPatientSummaries] = useState([]);
  const [fetchingSummaries, setFetchingSummaries] = useState(false);
  const [generatingRowId, setGeneratingRowId] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [openPDF, setOpenPDF] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [openprescriptionPdf, setOpenPrescriptionPdf] = useState(false);
  const isNavigatingForward = useRef(false);
  const [generatedSummaryUrl, setGeneratedSummaryUrl] = useState("");
  const [showSummaryReadyModal, setShowSummaryReadyModal] = useState(false);
  const [pendingEndFlow, setPendingEndFlow] = useState(null);
  const patientType = patientReducer?.patientInfo?.patientType || 'OBSTETRIC'
  const prescriptionReducer = useSelector((state) => state.prescriptionReducer);

  const [appointmentId, setAppointmentId] = useState(location.state?.appointmentId || null);
  const [appointmentMode, setAppointmentMode] = useState(() => {
    if (location.state?.appointmentMode) return location.state.appointmentMode;
    const apptId = location.state?.appointmentId;
    if (apptId) {
      try {
        return sessionStorage.getItem(`appointmentMode_${apptId}`) || null;
      } catch (e) {
        return null;
      }
    }
    return null;
  });
  const [isVideoCallOpen, setIsVideoCallOpen] = useState(
    Boolean(location.state?.autoJoinVideoCall) && location.state?.appointmentMode !== 'IN_PERSON'
  );
  const [showPostCallModal, setShowPostCallModal] = useState(false);
  const [hasLeftCall, setHasLeftCall] = useState(false);
  const authReducer = useSelector((state) => state.authReducer);
  const isReceptionOrNurse = authReducer?.userAttributes?.userTenant?.role?.name == "RECEPTIONIST" || authReducer?.userAttributes?.userTenant?.role?.name == "NURSE"

  useEffect(() => {
    if (location.state?.appointmentId) {
      setAppointmentId(location.state.appointmentId);
    }
    if (location.state?.appointmentMode) {
      setAppointmentMode(location.state.appointmentMode);
      if (location.state?.appointmentId) {
        try {
          sessionStorage.setItem(`appointmentMode_${location.state.appointmentId}`, location.state.appointmentMode);
        } catch (e) {}
      }
    }
    if (location.state?.autoJoinVideoCall && location.state?.appointmentMode !== 'IN_PERSON') {
      setIsVideoCallOpen(true);
    }
  }, [location.state?.autoJoinVideoCall, location.state?.appointmentId, location.state?.appointmentMode]);

  useEffect(() => {
    if (!appointmentId || appointmentMode) return;
    try {
      const stored = sessionStorage.getItem(`appointmentMode_${appointmentId}`);
      if (stored) {
        setAppointmentMode(stored);
        return;
      }
    } catch (e) {}

    API.get(END_POINTS.videoRoom(appointmentId))
      .then((res) => {
        const mode = (res?.success && res.data) ? 'VIDEO_CALL' : 'IN_PERSON';
        setAppointmentMode(mode);
        try {
          sessionStorage.setItem(`appointmentMode_${appointmentId}`, mode);
        } catch (e) {}
      })
      .catch(() => {
        setAppointmentMode('IN_PERSON');
      });
  }, [appointmentId, appointmentMode]);

  const isVideoCall = appointmentMode === 'VIDEO_CALL' || (Boolean(location.state?.autoJoinVideoCall) && appointmentMode !== 'IN_PERSON');

  useEffect(() => {
    if (!pendingEndFlow) return;

    if (consultationReducer?.consultationEndState === "SUCCESS") {
      const handoff = consultationReducer?.consultationEnd?.billingHandoff;
      const amountDue = handoff?.amountMinor != null
        ? ` Amount due: ${handoff.currency || "INR"} ${(handoff.amountMinor / 100).toFixed(2)}.`
        : "";
      if (handoff?.collectionStatus === "PENDING") {
        showToast(
          `Consultation completed. Payment collection has been handed to reception.${amountDue}`,
          "info",
        );
      } else if (handoff?.collectionStatus === "REVIEW_REQUIRED") {
        showToast(
          `Consultation completed. Billing needs review by reception.${amountDue}`,
          "warning",
        );
      }

      const shouldGeneratePdf = pendingEndFlow === "GENERATE_PDF";
      setPendingEndFlow(null);
      if (shouldGeneratePdf) {
        openModal();
      } else {
        navigate(`/dashboard`);
      }
      return;
    }

    if (consultationReducer?.consultationEndState === "FAILURE") {
      setPendingEndFlow(null);
      showToast(
        consultationReducer?.error || "Unable to end the consultation",
        "error",
      );
    }
  }, [consultationReducer?.consultationEndState, consultationReducer?.consultationEnd, consultationReducer?.error, navigate, pendingEndFlow, showToast]);

  useEffect(() => {
    isNavigatingForward.current = false;
  }, [route]);

  const navStyle = ({ isActive }, customActive = false) => {
    const active = customActive || isActive;
    return {
      fontSize: active ? "29px" : "27px",
      color: active ? "#F56432" : "black",
      textDecoration: "none",
      // backgroundColor: active ? "rgba(180, 193, 220, 0.5)" : "transparent",
      borderRadius: '20px',
      padding: 7,
    };
  };

  // useEffect(() => {
  //   if (!patientId) return;
  //   socket.emit("subscribeToPatientUpdates", {
  //     patientId,
  //   });

  //   return () => {
  //     socket.emit("unsubscribeFromPatientUpdates", {
  //       patientId,
  //     });
  //     // socket.off("commandOutput", handleCommandOutput);
  //   };
  // }, [patientId]);
  useEffect(() => {
    if (!patientId) return;
    const subscribe = () => {
      socket.emit("subscribeToPatientUpdates", {
        patientId,
      });
    };
    subscribe();
    socket.on("connect", subscribe);
    return () => {
      socket.emit("unsubscribeFromPatientUpdates", {
        patientId,
      });
      socket.off("connect", subscribe);
    };

  }, [patientId]);

  useEffect(() => {
    if (patientId) {
      store.dispatch(patientAction.getPatientDetailsRequestAction(patientId));
    }
  }, [patientId]);

  const isInitialMountHistory = useRef(true);

  useEffect(() => {
    if (isInitialMountHistory.current) {
      isInitialMountHistory.current = false;
      return;
    }
    if (
      patientReducer?.status === "update Patient history failure" ||
      patientReducer?.status === "create Patient history failure"
    ) {
      trackEvent("consultation_save_failed", {
        screen: "history",
      });
      isNavigatingForward.current = false;
      showToast("Failed to save patient history", "error");
    }
  }, [patientReducer?.status, patientReducer?.error]);

  const isInitialMountObservation = useRef(true);

  useEffect(() => {
    if (isInitialMountObservation.current) {
      isInitialMountObservation.current = false;
      return;
    }
    if (consultationReducer?.status === "Consulation updation failure") {
      isNavigatingForward.current = false;
      trackEvent("consultation_save_failed", {
        screen: "observation",
      });
      showToast("Failed to save observation", "error");
    }
    if (consultationReducer?.status === "Treatment updation failure") {
      isNavigatingForward.current = false;
      trackEvent("consultation_save_failed", {
        screen: "treatment",
      });
      showToast("Failed to save treatment", "error");
    }
  }, [consultationReducer?.status]);

  useEffect(() => {
    if (consultationReducer?.status === "consulation updated sucessfully") {
      if (route === "observation") {
        if (!isNavigatingForward.current) return;
        isNavigatingForward.current = false;
        store.dispatch(patientAction.getPatientRisksAssessRequestAction(patientId));
        store.dispatch(patientAction.getPatientDetailsRequestAction(patientId));
        if (hasPermission('TEST_VIEW')) {
          navigate(`A/antenatal?mode=${edit ? "edit" : "view"}`);
          return;
        }
        if (hasPermission('TREATMENT_VIEW')) {
          navigate(`A/treatment?mode=${edit ? "edit" : "view"}`);
          return;
        }
        navigate(`/dashboard`);
      }
      if (route == 'treatment' && patientType !== "GYNECOLOGY") {
        if (!isNavigatingForward.current) return;
        isNavigatingForward.current = false;
        // Navigate forward directly
        if (hasPermission('LEP_VIEW')) {
          navigate(`L?mode=${edit ? 'edit' : 'view'}`)
          return
        }
        navigate(`/dashboard`);
      }
      if (route == 'treatment' && patientType == "GYNECOLOGY") {
        if (!isNavigatingForward.current) return;
        isNavigatingForward.current = false;
        showToast("Treatment data saved", "success");
      }
    }
  }, [consultationReducer?.status]);

  useEffect(() => {
    if (
      (patientReducer?.status === "Patient history details updated sucessfully" ||
        patientReducer?.status === "Patient history details created sucessfully")
    ) {
      if (!isNavigatingForward.current) return;
      isNavigatingForward.current = false;
      store.dispatch(patientAction.getPatientRisksAssessRequestAction(patientId));
      if (hasPermission("VITALS_VIEW")) {
        navigate(`A/vitals?mode=${edit ? "edit" : "view"}`);
        return;
      }

      if (hasPermission("OBSERVATIONS_VIEW")) {
        navigate(`A/observation?mode=${edit ? "edit" : "view"}`);
        return;
      }

      if (hasPermission("TEST_VIEW")) {
        navigate(`A/antenatal?mode=${edit ? "edit" : "view"}`);
        return;
      }

      if (hasPermission("TREATMENT_VIEW")) {
        navigate(`A/treatment?mode=${edit ? "edit" : "view"}`);
        return;
      }
    }
  }, [patientReducer?.status]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const mode = queryParams.get("mode");
    if (mode) {
      setEdit(mode == "view" ? false : true);
    }
  }, [location.search]);

  useEffect(() => {
    if (patientId) {
      store.dispatch(patientAction.getPatientLeapScoreRequestAction(patientId));
    }
  }, [patientId]);

  useEffect(() => {
    if (patientReducer.leapScore) {
      setLeapScoreData(patientReducer.leapScore)
    }
  }, [patientReducer.leapScore])

  const fetchAllSummaries = async () => {
    try {
      trackEvent("summary_list_opened");
      setFetchingSummaries(true);
      const res = await API.get(END_POINTS.getPatientConsultationSummaries(patientId));
      setPatientSummaries(Array.isArray(res?.data) ? res.data : (res?.data?.data || []));
      setShowSummaryModal(true);
      setFetchingSummaries(false);
    } catch (err) {
      console.error(err);
      showToast("Failed to fetch summaries", "error");
      setFetchingSummaries(false);
    }
  };

  const generateSummaryForRow = async (consultId) => {
    try {
      trackEvent("summary_generate_started", {
        consultation_id: consultId,
      });
      setGeneratingRowId(consultId);

      const res = await API.post(END_POINTS.generateConsultationSummaryPdf(consultId),
        {}
      );

      const jobId = res?.data?.jobId;
      pollSummaryStatusForRow(jobId, consultId);
    } catch (err) {
      setGeneratingRowId(null);
      showToast("Failed to generate summary", "error");
    }
  };

  const pollSummaryStatusForRow = (jobId, consultId) => {
    const interval = setInterval(async () => {
      try {
        const res = await API.get(END_POINTS.getPdfStatus(jobId));
        const data = res?.data;
        if (data?.state === "completed") {
          clearInterval(interval);
          setGeneratingRowId(null);
          trackEvent("summary_generated");
          if (data?.pdfUrl) {
            setGeneratingRowId(null);
            if (isIOS || isMobile) {
              setGeneratedSummaryUrl(data.pdfUrl);
              setShowSummaryReadyModal(true);
            } else {
              setPreviewUrl(data.pdfUrl);
              trackEvent("summary_viewed");
              setOpenPDF(true);
            }
          }

          // try {
          //   const sumRes = await API.get(`/v1/consultations/patients/${patientId}/summary`);
          //   setPatientSummaries(Array.isArray(sumRes?.data) ? sumRes.data : (sumRes?.data?.data || []));
          // } catch(e){}
        }

        if (
          data?.state === "failed" ||
          data?.state === "failure"
        ) {
          clearInterval(interval);
          setGeneratingRowId(null);
          showToast("Failed to generate summary", "error");
        }
      } catch (err) {
        clearInterval(interval);
        setGeneratingRowId(null);
        showToast("Failed to fetch summary status", "error");
      }
    }, 2500);
  };

  const handleForward = async () => {
    isNavigatingForward.current = true;
    trackEvent("consultation_next_clicked", {
      consultation_id: consultationId,
      current_step: route,
    });
    if (route == "summary") {
      if (hasPermission('HISTORY_VIEW')) {
        navigate(`A/history?mode=${edit ? "edit" : "view"}`);
        return
      }
      if (hasPermission('VITALS_VIEW')) {
        navigate(`A/vitals?mode=${edit ? "edit" : "view"}`);
        return
      }
      if (hasPermission('OBSERVATIONS_VIEW')) {
        navigate(`A/observation?mode=${edit ? "edit" : "view"}`);
        return
      }
      if (hasPermission('TEST_VIEW')) {
        navigate(`A/antenatal?mode=${edit ? "edit" : "view"}`);
        return
      }
      if (hasPermission('TREATMENT_VIEW')) {
        navigate(`A/treatment?mode=${edit ? "edit" : "view"}`);
        return
      }
      if (hasPermission('LEP_VIEW')) {
        navigate(`L?mode=${edit ? 'edit' : 'view'}`)
        return
      }
    }

    if (route == "history") {

      if (patientReducer?.patientInfo?.lmp) {
        if (edit && hasPermission('HISTORY_CREATE')) {
          const { id, ...rest } = childData
          const payload = {
            blocks: Object.values(rest).map(block => ({
              code: block.code,
              data: block.data
            }))
          };

          if (id == false) {
            store.dispatch(
              patientAction.updatePatientHistoryDataRequestAction(
                patientId,
                payload
              )
            );
          } else {
            store.dispatch(
              patientAction.createPatientHistoryDataRequestAction(
                patientId,
                payload
              )
            );
          }
          return;
        }
        // not in edit mode — navigate forward 
        if (hasPermission('VITALS_VIEW')) {
          navigate(`A/vitals?mode=${edit ? "edit" : "view"}`);
          return
        }
        if (hasPermission("OBSERVATIONS_VIEW")) {
          navigate(`A/observation?mode=${edit ? "edit" : "view"}`);
          return;
        }
        if (hasPermission("TEST_VIEW")) {
          navigate(`A/antenatal?mode=${edit ? "edit" : "view"}`);
          return;
        }
        if (hasPermission("TREATMENT_VIEW")) {
          navigate(`A/treatment?mode=${edit ? "edit" : "view"}`);
          return;
        }
        navigate(`/dashboard`);
        return;
      }
      else {
        showToast("Lmp is Mandatory", "info");
        return;
      }
    }
    if (route == "observation") {
      if (edit && hasPermission('OBSERVATIONS_CREATE') && Object.keys(childData).length > 0) {
        store.dispatch(
          consultationActions.updateConsultationRequestAction(
            consultationId,
            childData
          )
        );
        return;
      }
      //  navigate forward directly
      if (hasPermission('TEST_VIEW')) {
        navigate(`A/antenatal?mode=${edit ? "edit" : "view"}`);
        return;
      }
      if (hasPermission('TREATMENT_VIEW')) {
        navigate(`A/treatment?mode=${edit ? "edit" : "view"}`);
        return;
      }
      navigate(`/dashboard`);
      return;
    }
    if (route == "vitals") {
      // const vitals = patientReducer.vitals
      // const isConsultationPresent = vitals.some(
      //   item => item.consultationId === consultationId
      // );

      // if (!isConsultationPresent) {
      //   showToast("Please submit vitals first.", "info");
      //   return;
      // }
      store.dispatch(patientAction.getPatientRisksAssessRequestAction(patientId));
      //  navigate forward directly
      if (hasPermission("OBSERVATIONS_VIEW")) {
        navigate(`A/observation?mode=${edit ? "edit" : "view"}`);
        return;
      }
      if (hasPermission('TEST_VIEW')) {
        navigate(`A/antenatal?mode=${edit ? "edit" : "view"}`);
        return;
      }
      if (hasPermission('TREATMENT_VIEW')) {
        navigate(`A/treatment?mode=${edit ? "edit" : "view"}`);
        return;
      }
      if (hasPermission('LEP_VIEW')) {
        navigate(`L?mode=${edit ? 'edit' : 'view'}`)
        return
      }
      navigate(`/dashboard`);
      return;
    }
    if (route == "antenatal") {
      store.dispatch(patientAction.getPatientRisksAssessRequestAction(patientId));
      if (hasPermission('TREATMENT_VIEW')) {
        navigate(`A/treatment?mode=${edit ? "edit" : "view"}`);
        return
      }
      if (hasPermission('LEP_VIEW')) {
        navigate(`L?mode=${edit ? 'edit' : 'view'}`)
        return
      }
      else {
        navigate(`/dashboard`);
        return
      }
    }

    if (route == "l") {
      if (edit && Object.keys(childData).length > 0 && hasPermission('LEP_CREATE')) {
        store.dispatch(
          patientAction.createOrUpdateRecommendedLifestyleRequestAction(
            consultationId,
            childData
          )
        );
      }
      navigate(`E?mode=${edit ? 'edit' : 'view'}`)
    }
    if (route == 'treatment' && patientType !== "GYNECOLOGY") {
      if (edit && hasPermission('TREATMENT_CREATE') && Object.keys(childData).length > 0) {
        store.dispatch(consultationActions.createUpdateTreatmentRequestAction(consultationId, childData))
        return
      }
      // Navigate forward directly 
      if (hasPermission('LEP_VIEW')) {
        navigate(`L?mode=${edit ? 'edit' : 'view'}`)
        return
      }
      navigate(`/dashboard`);
      return;
    }

    // GYNECOLOGY treatment: Save & Next just saves data (does not end consultation)
    if (route == 'treatment' && patientType === "GYNECOLOGY") {
      if (edit && hasPermission('TREATMENT_CREATE') && Object.keys(childData).length > 0) {
        store.dispatch(consultationActions.createUpdateTreatmentRequestAction(consultationId, childData))
      }
      return;
    }

  };

  const handleBackward = () => {
    trackEvent("consultation_previous_clicked", {
      consultation_id: consultationId,
      current_step: route,
    });
    if (route == "summary") {
      navigate(`/dashboard`);
    }
    if (route == "history") {
      navigate(`/dashboard`);
    }
    if (route == "vitals") {
      if (hasPermission('HISTORY_VIEW')) {
        navigate(`A/history?mode=${edit ? "edit" : "view"}`);
        return
      }
      if (patientReducer.patientInfo.isFirstTimeConsultation) {
        navigate(`/dashboard`);
      }
      else {
        navigate(`/dashboard`);
      }
    }
    if (route == "observation") {
      if (hasPermission('VITALS_VIEW')) {
        navigate(`A/vitals?mode=${edit ? "edit" : "view"}`);
        return
      }
      if (hasPermission('HISTORY_VIEW')) {
        navigate(`A/history?mode=${edit ? "edit" : "view"}`);
        return
      }
      if (patientReducer.patientInfo.isFirstTimeConsultation) {
        navigate(`/dashboard`);
      }
      else {
        navigate(`/dashboard`);
      }
    }
    if (route == "antenatal") {
      if (hasPermission('OBSERVATIONS_VIEW')) {
        navigate(`A/observation?mode=${edit ? "edit" : "view"}`);
        return
      }
      if (hasPermission('VITALS_VIEW')) {
        navigate(`A/vitals?mode=${edit ? "edit" : "view"}`);
        return
      }
      if (hasPermission('HISTORY_VIEW')) {
        navigate(`A/history?mode=${edit ? "edit" : "view"}`);
        return
      }
      if (patientReducer.patientInfo.isFirstTimeConsultation) {
        navigate(`/dashboard`);
      }
      else {
        navigate(`/dashboard`);
      }
    }
    if (route == "treatment") {
      store.dispatch(patientAction.getPatientRisksAssessRequestAction(patientId));
      if (hasPermission('TEST_VIEW')) {
        navigate(`A/antenatal?mode=${edit ? "edit" : "view"}`);
        return
      }
      if (hasPermission('OBSERVATIONS_VIEW')) {
        navigate(`A/observation?mode=${edit ? "edit" : "view"}`);
        return
      }
      if (hasPermission('VITALS_VIEW')) {
        navigate(`A/vitals?mode=${edit ? "edit" : "view"}`);
        return
      }
      if (hasPermission('HISTORY_VIEW')) {
        navigate(`A/history?mode=${edit ? "edit" : "view"}`);
        return
      }
      if (patientReducer.patientInfo.isFirstTimeConsultation) {
        navigate(`/dashboard`);
      }
      else {
        navigate(`/dashboard`);
      }
    }
    if (route == 'l') {
      if (hasPermission('TREATMENT_VIEW')) {
        navigate(`A/treatment?mode=${edit ? "edit" : "view"}`);
        return
      }
      if (hasPermission('TEST_VIEW')) {
        navigate(`A/antenatal?mode=${edit ? "edit" : "view"}`);
        return
      }
      if (hasPermission('OBSERVATIONS_VIEW')) {
        navigate(`A/observation?mode=${edit ? "edit" : "view"}`);
        return
      }
      if (hasPermission('VITALS_VIEW')) {
        navigate(`A/vitals?mode=${edit ? "edit" : "view"}`);
        return
      }
      if (hasPermission('HISTORY_VIEW')) {
        navigate(`A/history?mode=${edit ? "edit" : "view"}`);
        return
      }
    }
    if (route == 'e') {
      navigate(`L?mode=${edit ? 'edit' : 'view'}`)
    }

  }

  const endConsultation = async (generatePdfMode) => {
    try {

      if (!hasPermission("CONSULTATION_APPROVE")) {
        showToast(
          "You don't have permission to end the consultation. Redirecting to the dashboard.",
          "error"
        );
        navigate(`/dashboard`)
        return;
      }

      if (route == "p" || route == "e" || (route === "treatment" && patientType === "GYNECOLOGY")) {
        if (edit) {
          if (route === "treatment" && patientType === "GYNECOLOGY") {
            trackEvent("consultation_completed", {
              consultation_id: consultationId,
              patient_type: patientType,
            });
            // Treatment data is already saved via Save & Next; just end the consultation
            setPendingEndFlow(generatePdfMode ? "GENERATE_PDF" : "RETURN_TO_DASHBOARD");
            store.dispatch(consultationActions.endConsultationRequestAction(consultationId))
          }
          else {
            trackEvent("consultation_completed", {
              consultation_id: consultationId,
              patient_type: patientType,
            });
            setPendingEndFlow(generatePdfMode ? "GENERATE_PDF" : "RETURN_TO_DASHBOARD");
            store.dispatch(consultationActions.updatePhysicalDataRequestAction(consultationId, childData))
            store.dispatch(consultationActions.endConsultationRequestAction(consultationId))
          }
        }

        if (!edit) {
          setShowEndConsultationModal(false);
          if (generatePdfMode) {
            openModal();
          } else {
            navigate(`/dashboard`);
          }
          return;
        }

        setShowEndConsultationModal(false);
      }
    } catch (err) {
      console.error(err);
    }
  }

  const handlePause = () => {
    trackEvent("consultation_paused", {
      current_step: route,
    });
    localStorage.setItem('screen', JSON.stringify({ patientId, value: route }));
    localStorage.setItem("data", JSON.stringify(childData))
    navigate(`/dashboard`);
  }


  const generatePdf = async () => {
    try {
      trackEvent("prescription_generate_started", {
        consultation_id: consultationId,
      });
      setIsGenerating(true);
      const genRes = await API.post(
        `/v1/consultations/${consultationId}/prescription-pdf/generate`, {}
      );
      const jobId = genRes?.data?.jobId;
      pollPrescriptionStatus(jobId);
    } catch (err) {
      setIsGenerating(false);
    }
  };

  const openModal = async () => {
    try {
      const res = await API.get(
        `/v1/consultations/${consultationId}/prescription-pdf/info`
      );
      const data = res?.data;
      setHasSignature(data?.hasSignature || false);

      // If already generated
      if (data?.pdfUrl) {
        setPrescriptionUrl(data.pdfUrl);
        setShowPrescriptionModal(true);
        return;
      }
      if (!data?.hasData) {
        navigate(`/dashboard`)
        return
      }

      // If can generate → start generation
      if (data?.canGenerate) {
        generatePdf()
      }

      setShowPrescriptionModal(true);
    } catch (err) {
      console.error(err);
      showToast("Failed to load prescription", "error");
    }
  };

  const pollPrescriptionStatus = (jobId) => {
    const interval = setInterval(async () => {
      try {
        const res = await API.get(
          `/v1/consultations/prescription-pdf/status/${jobId}`
        );

        const data = res?.data;

        if (data?.state === "completed") {
          clearInterval(interval);
          trackEvent("prescription_generated");
          setPrescriptionUrl(data?.pdfUrl);
          setHasSignature(data?.hasSignature || false);
          setIsGenerating(false);
          showToast("Prescription ready", "success");
        }

        if (data?.state === "failed" || data?.state === "failure") {
          clearInterval(interval);
          setIsGenerating(false);
          showToast("Failed to generate prescription", "error");
          trackEvent("prescription_generation_failed");
          navigate("/dashboard");
        }
      } catch (err) {
        console.error(err);
        clearInterval(interval);
        setIsGenerating(false);
        showToast("Failed to fetch prescription", "error");
      }
    }, 2000); // every 2 sec
  };

  const handleUploadSignature = async () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const formData = new FormData();
      formData.append("file", file);

      const res = await API.post("/v1/providers/profile/signature", formData);

      if (res?.data) {
        setHasSignature(true);
        await generatePdf()
        // setHasSignature(true);
        // showToast("Signature uploaded successfully", "success");
      }
    } catch (err) {
      console.error(err);
      showToast("Upload failed", "error");
    }
    e.target.value = null;
  };

  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  const checkPdfModal = () => {
    const savedPrescription = prescriptionReducer.savedPrescription || [];
    const supplement = savedPrescription.find(p => p.type === 'SUPPLEMENT');
    const symptomBased = savedPrescription.find(p => p.type === 'SYMPTOM_BASED');
    const hasSavedDataLoaded = Array.isArray(savedPrescription) && savedPrescription.length > 0;
    const hasValidSaved = supplement || symptomBased;
    console.log("sdw", hasSavedDataLoaded, hasValidSaved)
    if (hasSavedDataLoaded && hasValidSaved) {
      const supplementData = supplement?.medicines || [];
      const symptomData = symptomBased?.medicines || [];
      console.log("data", supplementData, symptomData)
      if (supplementData.length > 0 || symptomData.length > 0) {
        setShowPdfPromptModal(true);
      }
      else {
        endConsultation(false)
      }
    } else {
      endConsultation(false)
    }
  }

  return (
    <ConsultationContext.Provider value={{ setChildData }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          height: { xs: "auto", md: "100vh" },
          minHeight: { xs: "100vh", md: "100vh" },
          overflow: { xs: "visible", md: "hidden" },
        }}
      >
        {/* LEFT SIDE - desktop sidebar */}
        {/* <Box
          sx={{
            // width: { xl: "14%", lg: '15%', md: '18%', },
            // background: "rgba(214, 236, 240, 1)",
            overflowY: 'auto',
            overflowX: 'hidden',
            height: '100vh',
            display: { xs: "none", md: "block" },
            border:'2px solid green'
          }}
        >
          <PatientInfo patientId={patientId} />
        </Box> */}

        {/* LEFT SIDE - mobile drawer */}
        {/* <Drawer
          anchor="left"
          open={patientDrawerOpen}
          onClose={() => setPatientDrawerOpen(false)}
          PaperProps={{
            sx: {
              width: '88%',
              maxWidth: 320,
              // backgroundColor: 'rgba(214, 236, 240, 1)',
              pt: 5,
              overflowY: 'auto',
            }
          }}
        >
          <IconButton
            onClick={() => setPatientDrawerOpen(false)}
            sx={{ position: 'absolute', top: 4, right: 4 }}
            aria-label="Close patient panel"
          >
            <CloseIcon />
          </IconButton>
          <PatientInfo patientId={patientId} />
        </Drawer> */}

        {/* RIGHT SIDE */}
        <Box
          sx={{
            flex: 1,
            // background: "rgba(214, 236, 240, 1)",
            overflow: { xs: "visible", md: "hidden" },
            width: { xs: "100%", md: "auto" },
            minWidth: 0,
          }}
        >
          {/* Mobile-only top bar with hamburger to open patient drawer */}
          <Box
            sx={{
              display: { xs: 'flex', md: 'none' },
            }}
          >
            <PatientHeader />
          </Box>

          {/* Mobile-only LEAP gauges row — shown only in view mode (when action nav is hidden) */}
          {!(edit || patientType == "GYNECOLOGY") && patientType !== "GYNECOLOGY" && (
            <Box
              sx={{
                display: { xs: 'flex', md: 'none' },
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                px: 1,
                py: 0.5,
                gap: 0.5,
                boxSizing: 'border-box',

              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, flex: 1, minWidth: 0, overflowX: 'auto', '&::-webkit-scrollbar': { height: 0 } }}>
                {/* <Box sx={{
                  height: 44,
                  width: 44,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: route == 'summary' ? "rgba(180, 193, 220, 0.5)" : "transparent",
                  borderRadius: '14px',
                  flexShrink: 0,
                }}>
                  <NavLink to={`summary?mode=view`} style={{ display: 'flex' }}>
                    <img src={taskIcon} style={{ width: 28, height: 30 }} alt="Tasks" />
                  </NavLink>
                </Box> */}
                {Object.keys(leapData).map((item) => {
                  const shouldHighlight = (
                    (['e', 'p'].includes(route) && ['e', 'p'].includes(item[0])) ||
                    (route === item[0]) ||
                    (item[0] === 'a' && exceptionRoute)
                  );
                  return (
                    <NavLink
                      key={item}
                      to={`${item[0].toUpperCase()}?mode=view`}
                      style={{ textDecoration: 'none', flexShrink: 0 }}
                    >
                      <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: 0.25,
                        fontSize: '18px',
                        fontWeight: 600,
                        color: shouldHighlight ? "#F56432" : "black",
                        border: shouldHighlight ? "1px solid #DADADA" : "transparent", 
                        // backgroundColor: shouldHighlight ? "rgba(180, 193, 220, 0.5)" : "transparent",
                        borderRadius: '14px',
                        px: 0.5,
                        py: 0.25,
                      }}>
                        {item[0].toUpperCase()}
                        <Box sx={{ width: 36, height: 36 }}>
                          <CircularProgressbar
                            text={
                              leapData[item] !== undefined && leapData[item] !== null
                                ? leapData[item]?.toFixed(1)
                                : "?"
                            }
                            value={
                              leapData[item] !== undefined
                                ? RenderProgress(leapData[item])
                                : 0
                            }
                            styles={buildStyles({
                              textSize: "30px",
                              pathTransitionDuration: 0.5,
                              pathColor: leapData[item] !== undefined ? RenderColor(leapData[item]) : "red",
                              textColor: "#000000",
                              trailColor: "#D3D3D3",
                            })}
                          />
                        </Box>
                      </Box>
                    </NavLink>
                  );
                })}
              </Box>
              <Tooltip title="Go to Dashboard">
                <IconButton
                  onClick={() => navigate('/dashboard')}
                  size="small"
                  sx={{
                    backgroundColor: 'rgba(238, 251, 255, 0.7)',
                    boxShadow: '0px 2px 4px rgba(0,0,0,0.2)',
                    flexShrink: 0,
                    ml: 0.5,
                  }}
                >
                  <HomeIcon sx={{ color: '#555', fontSize: 22 }} />
                </IconButton>
              </Tooltip>
            </Box>
          )}

          {patientReducer?.patientInfo?.lmpDate !== null && <Box sx={{ display: { xs: 'flex', md: 'none', justifyContent: 'space-evenly' } }}>
            <Button
              onClick={fetchAllSummaries}
              disabled={fetchingSummaries}
              sx={{
                backgroundColor: "transparent",
                color: 'black',
                "&:hover": {
                  backgroundColor: "transparent",
                  color: 'black',
                  fontWeight: 'bold'
                },
                border: '1px solid black',
                height: '30px',
                fontSize: '12px'
              }}
            >
              {fetchingSummaries ? "Loading..." : "View Summary"}
            </Button>
          </Box>}

          {/* Mobile-only compact top nav — no leap gauges, actions fit screen width */}
          {(edit || patientType == "GYNECOLOGY") && (
            <Box
              sx={{
                display: { xs: 'flex', md: 'none' },
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                px: 1,
                py: 0.5,
                gap: 0.5,
                boxSizing: 'border-box',
              }}
            >
              {/* <Box sx={{
                height: 40,
                width: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: route == 'summary' ? "rgba(180, 193, 220, 0.5)" : "transparent",
                borderRadius: '12px',
                flexShrink: 0,
              }}>
                <img src={taskIcon} style={{ width: 28, height: 30 }} alt="Tasks" />
              </Box> */}
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', flex: 1, minWidth: 0 }}>
                <Tooltip title="Go Back">
                  <Box onClick={handleBackward} sx={{ cursor: 'pointer', display: 'flex', p: 0.5 }}>
                    <LeftArrow style={{ width: 28, height: 28 }} />
                  </Box>
                </Tooltip>
                <Tooltip title={edit ? "Pause" : ''}>
                  <Box onClick={handlePause} sx={{ cursor: edit ? 'pointer' : 'default', display: 'flex', p: 0.5 }}>
                    <Pause style={{ color: !edit ? 'grey' : '#F56423', width: 28, height: 28 }} />
                  </Box>
                </Tooltip>
                <Tooltip title={(route !== "p" && route !== "e") ? "Save & Next" : ""}>
                  <Box onClick={handleForward} sx={{ cursor: 'pointer', display: 'flex', p: 0.5 }}>
                    {route == "p" || route == "e"
                      ? <DisabledRight style={{ width: 28, height: 28 }} />
                      : <RightArrow style={{ width: 28, height: 28 }} />}
                  </Box>
                </Tooltip>
                <Tooltip title={route == "p" || route == "e" || (route === "treatment" && patientType === "GYNECOLOGY") ? "End Consultation" : ''}>
                  <Box
                    onClick={() => {
                      if (route == "p" || route == "e" || (route === "treatment" && patientType === "GYNECOLOGY")) {
                        if (edit) {
                          trackEvent("consultation_end_clicked");
                          setShowEndConsultationModal((prev) => !prev);
                        }
                        else {
                          navigate('/dashboard')
                        }
                      }
                    }}
                    sx={{ cursor: 'pointer', display: 'flex', p: 0.5 }}
                  >
                    {route == "p" || route == "e" || (route == "treatment" && patientType == "GYNECOLOGY")
                      ? <EndConsult style={{ width: 28, height: 28 }} />
                      : <DisabledEnd style={{ width: 28, height: 28 }} />}
                  </Box>
                </Tooltip>
              </Box>
            </Box>
          )}

          <Box sx={{ display: { xs: 'none', md: 'flex' }, mt: 1, minHeight: 66, marginLeft: {xl:'20px', lg:'5px'}, }}>
            {/* Task icon */}
            {/* <Box sx={{ flexShrink: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {edit ? (
                <Box sx={{ height: "52px", width: '70px', alignContent: 'center', backgroundColor: route == 'summary' ? "rgba(180, 193, 220, 0.5)" : "transparent", borderRadius: '20px' }}>
                  <img src={taskIcon} style={{ width: 38, height: 40, alignSelf: 'center' }} />
                </Box>
              ) : (
                <NavLink to={`summary?mode=view`} style={navStyle}>
                  <Box sx={{ height: "52px", width: "70px", alignContent: 'center' }}>
                    <img src={taskIcon} style={{ width: 38, height: 40, alignSelf: 'center' }} />
                  </Box>
                </NavLink>
              )}
            </Box> */}
            {/* <PatientInfo patientId={patientId} /> */}
            <PatientHeader />
            <Box sx={{ width: { xl: '70px', lg: '10px' } }}></Box>
            {/* LEAP gauges */}
            {patientType !== "GYNECOLOGY" && Object.keys(leapData)?.map((item, index) => {
              const shouldHighlight = (
                (['e', 'p'].includes(route) && ['e', 'p'].includes(item[0])) ||
                (route === item[0]) ||
                (item[0] === 'a' && exceptionRoute)
              );
              return (
                <Box key={item} sx={{ flexShrink: 0, alignSelf: 'center', justifyContent: 'center' }}>
                  {!edit ? (
                    <NavLink
                      to={`${item[0].toUpperCase()}?mode=view`}
                      style={({ isActive }) => {
                        const customActive =
                          (['e', 'p'].includes(route) && ['e', 'p'].includes(item[0])) ||
                          (route === item[0]) ||
                          (item[0] === 'a' && exceptionRoute);
                        return navStyle({ isActive }, customActive);
                      }}
                    >
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', textDecoration: "none", border: shouldHighlight ? "1px solid #DADADA" : "transparent", borderRadius: '20px', padding: 7, }}>
                        <Typography sx={{ fontSize: "20px", color: shouldHighlight ? "#919191" : "#D3D3D3", }}>
                          {item[0].toUpperCase()}
                        </Typography>
                        <div style={{ width: "30px", display: "flex", flexDirection: "row" }}>
                          <CircularProgressbar
                            text={leapData[item] !== undefined && leapData[item] !== null ? leapData[item]?.toFixed(1) : "?"}
                            value={leapData[item] !== undefined ? RenderProgress(leapData[item]) : 0}
                            styles={buildStyles({ textSize: "30px", pathTransitionDuration: 0.5, pathColor: leapData[item] !== undefined ? RenderColor(leapData[item]) : "red", textColor: "#000000", trailColor: "#D3D3D3" })}
                          />
                        </div>
                      </div>
                    </NavLink>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', textDecoration: "none", border: shouldHighlight ? "1px solid #DADADA" : "transparent", borderRadius: '20px', padding: 7, }}>
                      <Typography sx={{ fontSize: "20px", color: shouldHighlight ? "#919191" : "#D3D3D3", }}>
                        {item[0].toUpperCase()}
                      </Typography>
                      <div style={{ width: "30px", display: "flex", flexDirection: "row" }}>
                        <CircularProgressbar
                          text={leapData[item] !== undefined && leapData[item] !== null ? leapData[item]?.toFixed(1) : "?"}
                          value={leapData[item] !== undefined ? RenderProgress(leapData[item]) : 0}
                          styles={buildStyles({ textSize: "30px", pathTransitionDuration: 0.5, pathColor: leapData[item] !== undefined ? RenderColor(leapData[item]) : "red", textColor: "#000000", trailColor: "#D3D3D3" })}
                        />
                      </div>
                    </div>
                  )}
                </Box>
              );
            })}

            {/* Flex spacer */}
            <Box sx={{ width: { xl: '100px', lg: '10px', md: '30px' } }} />

            {/* View mode: home button */}
            {!(edit || patientType == "GYNECOLOGY") && (
              <Tooltip title="Go to Dashboard">
                <IconButton
                  onClick={() => navigate('/dashboard')}
                  sx={{
                    width: 36,
                    height: 36,
                    alignSelf: 'center',
                    p: 0, backgroundColor: '#F2F2F2', boxShadow: '0px 2px 4px rgba(0,0,0,0.2)', '&:hover': { backgroundColor: 'rgba(238, 251, 255, 1)' }
                  }}
                >
                  <HomeIcon sx={{ color: '#555' }} />
                </IconButton>
              </Tooltip>
            )}
            {/* Edit mode: action buttons */}
            {(edit || patientType == "GYNECOLOGY") && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Tooltip title="Go Back">
                  <Box onClick={handleBackward} sx={{ cursor: 'pointer', display: 'flex' }}>
                    <img
                      src={require("../assets/left.svg").default}
                      alt="left-arrow"
                      style={{
                        width: 36,
                        height: 36,
                      }}
                    />
                  </Box>
                </Tooltip>
                <Tooltip title={edit ? "Pause" : ''}>
                  <Box onClick={handlePause} sx={{ cursor: edit ? 'pointer' : 'default', display: 'flex' }}>
                    <img
                      src={require("../assets/pause.svg").default}
                      alt="pause"
                      style={{
                        width: 32,
                        height: 32,
                      }}
                    />
                  </Box>
                </Tooltip>
                <Tooltip title={(route !== "p" && route !== "e") ? "Save & Next" : ""}>
                  <Box onClick={handleForward} sx={{ cursor: 'pointer', display: 'flex' }}>
                    {route == "p" || route == "e"
                      ? <img
                        src={require("../assets/disabledRight.svg").default}
                        alt="next"
                        style={{
                          width: 36,
                          height: 36,
                        }}
                      />
                      : <img
                        src={require("../assets/right.svg").default}
                        alt="save and next"
                        style={{
                          width: 36,
                          height: 36,
                        }}
                      />}
                  </Box>
                </Tooltip>
                <Tooltip title={route == "p" || route == "e" || (route === "treatment" && patientType === "GYNECOLOGY") ? "End Consultation" : ''}>
                  <Box
                    onClick={() => {
                      if (route == "p" || route == "e" || (route === "treatment" && patientType === "GYNECOLOGY")) {
                        if (edit) {
                          trackEvent("consultation_end_clicked");

                          setShowEndConsultationModal((prev) => !prev);
                        }
                        else {
                          navigate('/dashboard')
                        }
                      }
                    }}
                    sx={{ cursor: 'pointer', display: 'flex' }}
                  >
                    {route == "p" || route == "e" || (route == "treatment" && patientType == "GYNECOLOGY")
                      ? <img
                        src={require("../assets/end.svg").default}
                        alt="pause"
                        style={{
                          width: 34,
                          height: 34,
                        }}
                      />
                      : <img
                        src={require("../assets/disabledEnd.svg").default}
                        alt="pause"
                        style={{
                          width: 34,
                          height: 34,
                        }}
                      />}
                  </Box>
                </Tooltip>
              </Box>
            )}
            <Box sx={{ width: { xl: '90px', lg: '30px', md: '30px' }, }} />
            {patientReducer?.patientInfo?.lmpDate !== null && <Box sx={{ alignSelf: 'center',marginRight:'10px' }}>
              <Button
                onClick={fetchAllSummaries}
                disabled={fetchingSummaries}
                sx={{
                  backgroundColor: "transparent",
                  color: 'black',
                  "&:hover": {
                    backgroundColor: "transparent",
                    color: 'black',
                    fontWeight: 'bold'
                  },
                  border: '1px solid black',
                  fontSize: { xl: '12px', lg: '12px', md: '10px' },
                  height: '30px',
                  padding: 2
                }}
              >
                {fetchingSummaries ? "Loading..." : "View Summary"}
              </Button>
            </Box>}
            {appointmentId && !isReceptionOrNurse && isVideoCall && (
              <Box sx={{ alignSelf: 'center', marginRight: '10px' }}>
                <Button
                  onClick={() => {
                    if (hasLeftCall) {
                      showToast("The video call has already been ended for this consultation.", "info");
                    } else {
                      setIsVideoCallOpen(true);
                    }
                  }}
                  disabled={isVideoCallOpen}
                  sx={{
                    backgroundColor: "transparent",
                    color: 'black',
                    "&:hover": {
                      backgroundColor: "transparent",
                      color: 'black',
                      fontWeight: 'bold'
                    },
                    border: '1px solid black',
                    fontSize: { xl: '12px', lg: '12px', md: '10px' },
                    height: '30px',
                    padding: 2
                  }}
                >
                  Video Call
                </Button>
              </Box>
            )}


            <Modal
              open={showSummaryModal}
              onClose={() => setShowSummaryModal(false)}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 2,
              }}
              BackdropProps={{
                sx: {
                  backdropFilter: "blur(6px)",
                  backgroundColor: "rgba(0,0,0,0.25)",
                },
              }}
            >
              <Box
                sx={{
                  width: {
                    xs: "95%",
                    sm: "90%",
                    md: "700px",
                  },
                  maxHeight: "85vh",
                  overflowY: "auto",
                  bgcolor: "#fff",
                  borderRadius: {
                    xs: "20px",
                    sm: "28px",
                  },
                  p: {
                    xs: 1.5,
                    sm: 2,
                    md: 3,
                  },
                  boxShadow: "0px 20px 60px rgba(0,0,0,0.18)",
                  border: "1px solid rgba(255,255,255,0.4)",
                }}
              >
                {/* HEADER */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    mb: {
                      xs: 2,
                      sm: 3,
                    },
                    gap: 1,
                  }}
                >
                  <Box display="flex" gap={1.5}>
                    <Box
                      sx={{
                        width: {
                          xs: 42,
                          sm: 50,
                          md: 58,
                        },
                        height: {
                          xs: 40,
                          sm: 45,
                          md: 50,
                        },
                        borderRadius: "16px",
                        background: "#EEF4FF",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexShrink: 0,
                      }}
                    >
                      <TextSnippetIcon
                        sx={{
                          color: "#2563EB",
                          fontSize: {
                            xs: 22,
                            sm: 26,
                          },
                        }}
                      />
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "16px",
                            sm: "24px",
                            md: "20px",
                          },
                          fontWeight: 500,
                          color: "#0F172A",
                          lineHeight: 1.2,
                        }}
                      >
                        Consultation Summaries
                      </Typography>
                    </Box>
                  </Box>

                  <IconButton
                    onClick={() => setShowSummaryModal(false)}
                    sx={{
                      background: "#F4F4F5",
                      width: {
                        xs: 34,
                        sm: 42,
                      },
                      height: {
                        xs: 34,
                        sm: 42,
                      },

                      "&:hover": {
                        background: "#E4E4E7",
                      },
                    }}
                  >
                    <ClearIcon
                      sx={{
                        fontSize: {
                          xs: 20,
                          sm: 24,
                        },
                      }}
                    />
                  </IconButton>
                </Box>

                {/* EMPTY STATE */}
                {patientSummaries.length === 0 ? (
                  <Typography
                    sx={{
                      textAlign: "center",
                      py: 6,
                      color: "#777",
                      fontSize: "15px",
                    }}
                  >
                    No summaries available.
                  </Typography>
                ) : (
                  <Box>
                    {patientSummaries.map((summary, idx) => {
                      const cId = summary.id;
                      const dateStr = summary.createdAt;

                      const displayDate = dateStr
                        ? new Date(dateStr).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        : `Consultation ${idx + 1}`;

                      const displayDay = dateStr
                        ? new Date(dateStr).toLocaleDateString("en-GB", {
                          weekday: "long",
                        })
                        : "";

                      const pUrl = summary.pdfUrl || summary.url;

                      const isGen = generatingRowId === cId;

                      return (
                        <Box
                          key={cId || idx}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: {
                              xs: "flex-start",
                              sm: "center",
                            },

                            flexDirection: {
                              xs: "column",
                              sm: "row",
                            },
                            gap: {
                              xs: 1.5,
                              sm: 2,
                            },

                            p: {
                              xs: 1,
                              sm: 2,
                              md: 1,
                            },
                            mb: 2,
                            borderRadius: {
                              xs: "16px",
                              md: "22px",
                            },
                            background: "#FFFFFF",
                            border: "1px solid #EEF2F6",
                            boxShadow: "0px 4px 20px rgba(15,23,42,0.06)",
                            transition: "all 0.25s ease",

                            "&:hover": {
                              transform: "translateY(-2px)",
                              boxShadow: "0px 10px 30px rgba(15,23,42,0.10)",
                            },
                          }}
                        >
                          {/* LEFT */}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: {
                                xs: 1.2,
                                sm: 2,
                              },
                              width: {
                                xs: "100%",
                                sm: "auto",
                              },
                            }}
                          >
                            <Box
                              sx={{
                                width: {
                                  xs: 42,
                                  sm: 50,
                                },
                                height: {
                                  xs: 38,
                                  sm: 44,
                                },
                                borderRadius: "14px",
                                background: "#EEF4FF",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexShrink: 0,
                              }}
                            >
                              <PendingActionsOutlinedIcon
                                sx={{
                                  color: "#2563EB",
                                  fontSize: {
                                    xs: 22,
                                    sm: 26,
                                  },
                                }}
                              />
                            </Box>

                            <Box>
                              <Typography
                                sx={{
                                  fontWeight: 700,

                                  fontSize: {
                                    xs: "15px",
                                    sm: "15px",
                                    md: "14px",
                                  },

                                  color: "#0F172A",
                                }}
                              >
                                {displayDate}
                              </Typography>

                              <Typography
                                sx={{
                                  color: "#667085",

                                  fontSize: {
                                    xs: "12px",
                                    sm: "13px",
                                    md: "13px",
                                  },

                                  mt: 0.3,
                                }}
                              >
                                {displayDay}
                              </Typography>
                            </Box>
                          </Box>

                          {/* BUTTON */}
                          {(
                            <Button
                              variant="contained"
                              disabled={isGen || !cId}
                              onClick={() => {
                                if (cId) generateSummaryForRow(cId);
                              }}
                              startIcon={
                                isGen ? (
                                  <CircularProgress
                                    size={16}
                                    sx={{
                                      color: 'white'
                                    }}
                                  />
                                ) : (
                                  <TextSnippetIcon />
                                )
                              }
                              sx={{
                                height: {
                                  xs: 32,
                                  sm: 36,
                                  md: 35,
                                },
                                width: {
                                  xs: "100%",
                                  sm: "auto",
                                },
                                px: {
                                  xs: 2,
                                  sm: 2.5,
                                },
                                borderRadius: "14px",
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: {
                                  xs: "10px",
                                  sm: "12px",
                                  md: "13px",
                                },
                                background:
                                  "linear-gradient(135deg,#2563EB 0%,#1D4ED8 100%)",
                                "&.Mui-disabled": {
                                  color: "white",
                                  background:
                                    "linear-gradient(135deg,#2563EB 0%,#1D4ED8 100%)",
                                  opacity: 0.8,
                                },
                              }}
                            >
                              {isGen ? "Generating..." : "Generate PDF"}
                            </Button>
                          )}
                        </Box>
                      );
                    })}
                  </Box>
                )}
              </Box>
            </Modal>
          </Box>
          {/* <Divider sx={{ margin:'10px'}}></Divider> */}
          <Modal
            open={showEndConsultationModal}
            onClose={() => setShowEndConsultationModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            BackdropProps={{
              sx: {
                backdropFilter: 'blur(5px)',
              }
            }}
          >
            <Box sx={{ ...style, }}>
              <Typography sx={{ textAlign: 'center', fontSize: { xs: '14px', sm: '15px', md: '15px', lg: '17px', xl: '19px' } }}>Are you sure you want to end the consultation?</Typography>
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: { xs: 'center', sm: 'space-between' }, width: { xs: '100%', sm: '355px' }, alignSelf: 'center', gap: { xs: 1.5, sm: 0 }, mt: { xs: 1.5, sm: 0 } }}>
                <Box sx={{ ...actionButtonStyle, backgroundColor: '#FFF' }} onClick={() => {
                  setShowEndConsultationModal(false);
                }}>
                  <Typography sx={{ cursor:'pointer'}}>
                    Cancel
                  </Typography>
                </Box>
                <Box sx={{ ...actionButtonStyle, backgroundColor: '#D3D3D3' }} onClick={() => {
                  setShowEndConsultationModal(false);
                  checkPdfModal()
                }}>
                  <Typography sx={{ cursor:'pointer'}}>
                    End Consultation
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Modal>

          <Modal
            open={showSummaryReadyModal}
            onClose={() => setShowSummaryReadyModal(false)}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 2,
            }}
            BackdropProps={{
              sx: {
                backdropFilter: "blur(6px)",
                backgroundColor: "rgba(0,0,0,0.25)",
              },
            }}
          >
            <Box sx={{ ...style, position: 'relative' }}>
              <IconButton
                onClick={() => setShowSummaryReadyModal(false)}
                sx={{ position: 'absolute', top: 4, right: 4 }}
              >
                <ClearIcon />
              </IconButton>
              <Typography>
                Summary PDF is ready
              </Typography>

              <Button
                component="a"
                href={generatedSummaryUrl}
                target="_blank"
                rel="noopener noreferrer"
                variant="contained"
              >
                Open PDF
              </Button>
            </Box>
          </Modal>

          <Modal
            open={showPdfPromptModal}
            onClose={() => setShowPdfPromptModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            BackdropProps={{
              sx: {
                backdropFilter: 'blur(5px)',
              }
            }}
          >
            <Box sx={{ ...style, position: 'relative' }}>
              <IconButton
                onClick={() => {
                  setShowPdfPromptModal(false)
                  endConsultation(false)
                }}
                sx={{ position: 'absolute', top: 4, right: 4 }}
              >
                <ClearIcon />
              </IconButton>
              <Typography sx={{ textAlign: 'center', mt: 3, fontSize: { xs: '14px', sm: '15px', md: '15px', lg: '17px', xl: '19px' } }}>Do you want to generate the PDF for prescription?</Typography>
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '100%', maxWidth: '355px', alignSelf: 'center', gap: 2, mt: { xs: 1.5, sm: 0 } }}>
                <Box sx={{ ...actionButtonStyle, backgroundColor: '#FFF', flex: 'none', width: { xs: '90px', sm: '100px', md: '110px' } }} onClick={() => {
                  setShowPdfPromptModal(false);
                  endConsultation(false)
                }}>
                  <Typography sx={{ cursor:'pointer'}}>
                    No
                  </Typography>
                </Box>
                <Box sx={{ ...actionButtonStyle, flex: 'none', width: { xs: '90px', sm: '100px', md: '110px' }, backgroundColor:'#D3D3D3' }} onClick={() => {
                  setShowPdfPromptModal(false);
                  endConsultation(true)
                }}>
                  <Typography sx={{ cursor:'pointer'}}>
                    Yes
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Modal>

          <Modal
            open={showPrescriptionModal}
            onClose={() => setShowPrescriptionModal(false)}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: { xs: 2, sm: 0 },
            }}
            BackdropProps={{
              sx: { backdropFilter: "blur(5px)" },
            }}
          >
            <Box
              sx={{
                width: { xs: '90%', sm: '450px', md: '577px' },
                bgcolor: "#fff",
                borderRadius: "12px",
                p: { xs: 2, sm: 3 },
                textAlign: "center",
              }}
            >
              <Box sx={{ justifySelf: 'flex-end' }}>
                <Typography sx={{ fontSize: "20px", cursor: 'pointer' }} onClick={() => {
                  setShowPrescriptionModal(false)
                  navigate(`/dashboard`)
                }}><ClearIcon /></Typography>
              </Box>
              {
                isGenerating ? <CircularProgress sx={{ color: 'green', fontSize: '60px' }} /> : hasSignature ? <CheckCircleIcon sx={{ color: 'green', fontSize: '60px' }} /> : <ErrorIcon sx={{ color: 'red', fontSize: '60px' }} />
              }

              {/* Title */}

              {isGenerating ? (
                <>
                  <Typography mt={2}>
                    Generating prescription, please wait...
                  </Typography>
                </>
              ) : !hasSignature ? (
                <Typography textAlign="center" fontSize="16px" sx={{ fontWeight: '600', marginTop: '9px', px: { xs: 2, sm: 4, md: '75px' } }}>
                  Consultation complete! Your signature isn't set up yet. Add signature to auto-apply it to prescriptions. Would you like to Add signature now
                </Typography>
              ) : (
                <>
                  <Typography fontWeight="bold" mt={1} fontSize="16px" sx={{ fontWeight: '600', fontFamily: 'Roboto', }} >
                    Consultation complete!
                  </Typography>
                  <Typography textAlign="center" fontSize="16px" mt={1}>
                    Would you like to share the prescription with your patient?
                  </Typography>
                </>
              )}

              {/* File box */}
              <Box
                sx={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  mt: '24px',
                  width: { xs: '100%', sm: '434px' },
                  maxWidth: '434px',
                  justifySelf: 'center',
                  flexDirection: 'row',
                  display: 'flex',
                  paddingLeft: '12px',
                  paddingTop: '8px',
                  paddingBottom: '8px',
                  boxSizing: 'border-box',
                }}
              >
                <Box sx={{ width: '48px', borderRadius: '12px', border: "1px solid #ddd", display: 'flex', justifyContent: 'center', alignItems: 'center', height: '48px', flexShrink: 0 }}>
                  <TextSnippetIcon sx={{ color: 'rgba(204, 204, 204, 1)' }} />
                </Box>
                <Box sx={{ marginLeft: '12px' }}>
                  <Typography sx={{ textAlign: 'left', fontSize: '16px' }}>Prescription</Typography>
                  <Typography sx={{ textAlign: 'left', fontSize: '16px' }}>PDF
                  </Typography>
                </Box>
              </Box>

              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              {/* Buttons */}
              {isGenerating ? null : !hasSignature ? (
                <Button
                  fullWidth
                  variant="contained"
                  sx={{ mt: 2, justifySelf: 'center', width: '165px', height: '40px', borderRadius: '12px', backgroundColor: 'rgba(214, 244, 255, 1)', color: 'rgba(18, 18, 18, 1)' }}
                  onClick={() => {
                    handleUploadSignature();
                  }}
                >
                  Upload Signature
                </Button>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: '24px',
                    justifySelf: 'center',
                  }}
                >
                  {/* vIEW & Print */}
                  <Button
                    variant="contained"
                    disabled={!prescriptionUrl}
                    {...((isIOS || isMobile)
                      ? {
                        component: "a",
                        href: prescriptionUrl,
                        target: "_blank",
                        rel: "noopener noreferrer",
                      }
                      : {
                        onClick: () => {
                          setOpenPrescriptionPdf(true)
                          trackEvent("prescription_viewed");
                        }
                      })}
                    sx={{
                      width: "190px",
                      height: "42px",
                      borderRadius: "12px",
                      backgroundColor: "rgba(214, 244, 255, 1)",
                      color: "rgba(18, 18, 18, 1)",
                    }}
                  >
                    View & Print
                  </Button>
                </Box>
              )}
            </Box>
          </Modal>

          <Dialog
            open={openPDF}
            onClose={() => setOpenPDF(false)}
            maxWidth="md"
            fullWidth
            fullScreen={isMobile}
          >
            <IconButton
              onClick={() => setOpenPDF(false)}
              sx={{
                position: "absolute",
                top: 0,
                right: 10,
                zIndex: 2000,
                backgroundColor: "#fff",
              }}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent sx={{ position: "relative", p: 2 }}>
              <iframe
                src={`${previewUrl}#toolbar=1`}
                title="pdf-preview"
                width="100%"
                height={isMobile ? "100%" : "600px"}
                style={{
                  border: "none",
                  minHeight: "600px",
                }}
              />
            </DialogContent>
          </Dialog>

          <Dialog
            open={openprescriptionPdf}
            onClose={() => setOpenPrescriptionPdf(false)}
            maxWidth="md"
            fullWidth
            fullScreen={isMobile}
          >
            <IconButton
              onClick={() => setOpenPrescriptionPdf(false)}
              sx={{
                position: "absolute",
                top: 0,
                right: 10,
                zIndex: 2000,
                backgroundColor: "#fff",
              }}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent sx={{ position: "relative", p: 2 }}>
              <iframe
                src={`${prescriptionUrl}#toolbar=1`}
                title="pdf-preview"
                width="100%"
                height={isMobile ? "100%" : "600px"}
                style={{
                  border: "none",
                  minHeight: "600px",
                }}
              />
            </DialogContent>
          </Dialog>
          <Outlet />
        </Box>
      </Box>

      <Dialog
        open={showPostCallModal}
        onClose={() => setShowPostCallModal(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: { borderRadius: "16px", p: 1 },
        }}
      >
        <DialogContent sx={{ textAlign: "center", py: 4 }}>
          <CheckCircleIcon sx={{ fontSize: 60, color: "#10B981", mb: 2 }} />
          <Typography variant="h5" fontWeight={600} gutterBottom>
            Call Ended
          </Typography>
          <Typography variant="body1" color="text.secondary" mb={3}>
            You have left the video call. You can continue filling out the consultation notes. Please remember to manually end the consultation when you are finished.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ py: 1.5, borderRadius: 2, textTransform: "none", fontSize: "16px" }}
            onClick={() => setShowPostCallModal(false)}
          >
            Continue Consultation
          </Button>
        </DialogContent>
      </Dialog>

      {isVideoCallOpen && appointmentId && isVideoCall && (
        <VideoCall 
          isModal={true} 
          appointmentId={appointmentId} 
          patientName={[patientReducer?.patientDetails?.firstName, patientReducer?.patientDetails?.lastName].filter(Boolean).join(' ') || location.state?.patientName}
          patientId={patientId}
          consultationId={consultationId}
          onClose={() => setIsVideoCallOpen(false)} 
          onCallLeft={() => {
            setIsVideoCallOpen(false);
            setHasLeftCall(true);
            setShowPostCallModal(true);
          }}
        />
      )}
    </ConsultationContext.Provider>
  );
};

export default Consultation;